var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/alternate-category-facet-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/alternate-category-facet-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/alternate-category-facet-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
var macro_t_9 = runtime.makeMacro(
["breadcrumbs", "bcIndex", "bcLength", "selectedId"], 
["class", "nested"], 
function (l_breadcrumbs, l_bcIndex, l_bcLength, l_selectedId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("breadcrumbs", l_breadcrumbs);
frame.set("bcIndex", l_bcIndex);
frame.set("bcLength", l_bcLength);
frame.set("selectedId", l_selectedId);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("nested", kwargs.hasOwnProperty("nested") ? kwargs["nested"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_10 = "";t_10 += "\n    ";
if(l_bcIndex < l_bcLength && l_breadcrumbs && runtime.memberLookup((l_breadcrumbs),l_bcIndex)) {
t_10 += "\n        ";
var t_11;
t_11 = runtime.memberLookup((l_breadcrumbs),l_bcIndex);
frame.set("crumb", t_11, true);
if(frame.topLevel) {
context.setVariable("crumb", t_11);
}
if(frame.topLevel) {
context.addExport("crumb", t_11);
}
t_10 += "\n        ";
var t_12;
t_12 = (runtime.memberLookup((runtime.memberLookup((l_breadcrumbs),0)),"parentSlug") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"marketingNavSlug"));
frame.set("crumbIsChildOfMarketingSlug", t_12, true);
if(frame.topLevel) {
context.setVariable("crumbIsChildOfMarketingSlug", t_12);
}
if(frame.topLevel) {
context.addExport("crumbIsChildOfMarketingSlug", t_12);
}
t_10 += "\n        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs")) > 0) || runtime.contextOrFrameLookup(context, frame, "crumbIsChildOfMarketingSlug")) {
t_10 += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "nested")) {
t_10 += "\n                ";
var t_13;
t_13 = "o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__ul" + "" + "--nested";
frame.set("nestedListClass", t_13, true);
if(frame.topLevel) {
context.setVariable("nestedListClass", t_13);
}
if(frame.topLevel) {
context.addExport("nestedListClass", t_13);
}
t_10 += "\n                ";
var t_14;
t_14 = "o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--nested";
frame.set("nestedAnchorClass", t_14, true);
if(frame.topLevel) {
context.setVariable("nestedAnchorClass", t_14);
}
if(frame.topLevel) {
context.addExport("nestedAnchorClass", t_14);
}
t_10 += "\n            ";
;
}
else {
t_10 += "\n                ";
var t_15;
t_15 = "";
frame.set("nestedListClass", t_15, true);
if(frame.topLevel) {
context.setVariable("nestedListClass", t_15);
}
if(frame.topLevel) {
context.addExport("nestedListClass", t_15);
}
t_10 += "\n                ";
var t_16;
t_16 = "";
frame.set("nestedAnchorClass", t_16, true);
if(frame.topLevel) {
context.setVariable("nestedAnchorClass", t_16);
}
if(frame.topLevel) {
context.addExport("nestedAnchorClass", t_16);
}
t_10 += "\n            ";
;
}
t_10 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "crumbIsChildOfMarketingSlug")) {
t_10 += "\n                ";
var t_17;
t_17 = runtime.memberLookup((l_breadcrumbs),0);
frame.set("crumb", t_17, true);
if(frame.topLevel) {
context.setVariable("crumb", t_17);
}
if(frame.topLevel) {
context.addExport("crumb", t_17);
}
t_10 += "\n            ";
;
}
t_10 += "\n\n           ";
t_10 += "\n            <ul itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\" class=\"";
t_10 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__ul", env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedListClass"), env.opts.autoescape);
t_10 += " js-accordion\" role=\"menu\" data-qa-category-navitems>\n            ";
frame = frame.push();
var t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs");
if(t_20) {var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("childSlug", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
t_10 += "\n                ";
var t_22;
t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_21);
frame.set("navItem", t_22, true);
if(frame.topLevel) {
context.setVariable("navItem", t_22);
}
if(frame.topLevel) {
context.addExport("navItem", t_22);
}
t_10 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
t_10 += "\n\n                    ";
var t_23;
t_23 = (runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"itemId") == l_selectedId?"o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--current":"");
frame.set("currentlyActive", t_23, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_23);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_23);
}
t_10 += "\n\n                    ";
t_10 += runtime.suppressValue((lineno = 44, colno = 69, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_24 = runtime.makeMacro(
["navItemToRender", "url", "target"], 
[], 
function (l_navItemToRender, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItemToRender", l_navItemToRender);
frame.set("url", l_url);
frame.set("target", l_target);
var t_25 = "";t_25 += "\n                        ";
var t_26;
t_26 = "noopener noreferrer";
frame.set("rel", t_26, true);
if(frame.topLevel) {
context.setVariable("rel", t_26);
}
if(frame.topLevel) {
context.addExport("rel", t_26);
}
t_25 += "\n\n                        <li itemprop=\"name\" class=\"";
t_25 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li", env.opts.autoescape);
t_25 += "\" role=\"menuitem\">\n                            <meta itemprop=\"url\" content=\"";
t_25 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + l_url)), env.opts.autoescape);
t_25 += "\" />\n\n                            <a ";
if(l_target) {
t_25 += "target=\"";
t_25 += runtime.suppressValue(l_target, env.opts.autoescape);
t_25 += "\" ";
if(l_target == "_blank") {
t_25 += " rel=\"";
t_25 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_25 += "\" ";
;
}
;
}
t_25 += " data-bc-index=";
t_25 += runtime.suppressValue(l_bcIndex, env.opts.autoescape);
t_25 += " href=\"";
t_25 += runtime.suppressValue(l_url, env.opts.autoescape);
t_25 += "\" class=\"";
t_25 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_25 += " ";
t_25 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedAnchorClass"), env.opts.autoescape);
t_25 += " ";
t_25 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
t_25 += " ";
t_25 += runtime.suppressValue("js-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_25 += "\" role=\"menuitem\" data-qa-category-navitem=\"";
t_25 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug"), env.opts.autoescape);
t_25 += "\" ";
t_25 += runtime.suppressValue((lineno = 50, colno = 299, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 50, colno = 305, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"gaLabel")])), env.opts.autoescape);
t_25 += ">";
t_25 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_25 += "</a>\n\n                            ";
t_25 += "\n                            ";
if(l_bcIndex + 1 < l_bcLength && runtime.memberLookup((l_breadcrumbs),l_bcIndex + 1) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"itemId") == runtime.memberLookup((runtime.memberLookup((l_breadcrumbs),l_bcIndex + 1)),"itemId")) {
t_25 += "\n                                ";
t_25 += runtime.suppressValue((lineno = 56, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "alternateBuildExplodedBreadcrumbNav"), "alternateBuildExplodedBreadcrumbNav", context, [l_breadcrumbs,l_bcIndex + 1,l_bcLength,l_selectedId,runtime.contextOrFrameLookup(context, frame, "class"),runtime.contextOrFrameLookup(context, frame, "True")])), env.opts.autoescape);
t_25 += "\n                            ";
;
}
t_25 += "\n                        </li>\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_25);
});
return macro_t_24;})()})])), env.opts.autoescape);
t_10 += "\n\n                ";
;
}
t_10 += "\n\n            ";
;
}
}
frame = frame.pop();
t_10 += "\n            </ul>\n        ";
;
}
t_10 += "\n    ";
;
}
t_10 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("alternateBuildExplodedBreadcrumbNav");
context.setVariable("alternateBuildExplodedBreadcrumbNav", macro_t_9);
var macro_t_27 = runtime.makeMacro(
["categorySlug", "core"], 
["class", "isSubnav"], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("isSubnav", kwargs.hasOwnProperty("isSubnav") ? kwargs["isSubnav"] : false);
var t_28 = "";if(runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)) {
var t_29;
t_29 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug);
frame.set("currentNavigationItem", t_29, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItem", t_29);
}
if(frame.topLevel) {
context.addExport("currentNavigationItem", t_29);
}
var t_30;
t_30 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"parentSlug"));
frame.set("currentNavigationItemParent", t_30, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParent", t_30);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParent", t_30);
}
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs")) > 0) {
if(runtime.contextOrFrameLookup(context, frame, "isSubnav")) {
t_28 += runtime.suppressValue((lineno = 87, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildOffscreenNav"), "buildOffscreenNav", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
else {
t_28 += runtime.suppressValue((lineno = 89, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "loopThroughChildSlugs"), "loopThroughChildSlugs", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_28);
});
context.addExport("getCategoryNavigation");
context.setVariable("getCategoryNavigation", macro_t_27);
var macro_t_31 = runtime.makeMacro(
["childSlugs", "categorySlug"], 
["class"], 
function (l_childSlugs, l_categorySlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("childSlugs", l_childSlugs);
frame.set("categorySlug", l_categorySlug);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_32 = "";t_32 += "\n    <ul class=\"";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_32 += "\" data-qa-category-navitems>";
frame = frame.push();
var t_35 = l_childSlugs;
if(t_35) {var t_34 = t_35.length;
for(var t_33=0; t_33 < t_35.length; t_33++) {
var t_36 = t_35[t_33];
frame.set("slug", t_36);
frame.set("loop.index", t_33 + 1);
frame.set("loop.index0", t_33);
frame.set("loop.revindex", t_34 - t_33);
frame.set("loop.revindex0", t_34 - t_33 - 1);
frame.set("loop.first", t_33 === 0);
frame.set("loop.last", t_33 === t_34 - 1);
frame.set("loop.length", t_34);
var t_37;
t_37 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_36);
frame.set("navItem", t_37, true);
if(frame.topLevel) {
context.setVariable("navItem", t_37);
}
if(frame.topLevel) {
context.addExport("navItem", t_37);
}
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
var t_38;
t_38 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug");
frame.set("itemSlug", t_38, true);
if(frame.topLevel) {
context.setVariable("itemSlug", t_38);
}
if(frame.topLevel) {
context.addExport("itemSlug", t_38);
}
if(runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.contextOrFrameLookup(context, frame, "itemSlug") == l_categorySlug) {
var t_39;
t_39 = "c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a" + "--current";
frame.set("currentlyActive", t_39, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_39);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_39);
}
;
}
else {
var t_40;
t_40 = "";
frame.set("currentlyActive", t_40, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_40);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_40);
}
;
}
t_32 += "<li class=\"";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_32 += "\"><a href=\"";
t_32 += runtime.suppressValue((lineno = 116, colno = 67, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "itemSlug")])), env.opts.autoescape);
t_32 += "\" class=\"";
t_32 += runtime.suppressValue("js-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
t_32 += "\">";
t_32 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_32 += "</a></li>\n        ";
;
}
;
}
}
frame = frame.pop();
t_32 += "</ul>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_32);
});
context.addExport("loopThroughChildSlugs");
context.setVariable("loopThroughChildSlugs", macro_t_31);
var macro_t_41 = runtime.makeMacro(
["childSlugs", "categorySlug"], 
["class"], 
function (l_childSlugs, l_categorySlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("childSlugs", l_childSlugs);
frame.set("categorySlug", l_categorySlug);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_42 = "";frame = frame.push();
var t_45 = l_childSlugs;
if(t_45) {var t_44 = t_45.length;
for(var t_43=0; t_43 < t_45.length; t_43++) {
var t_46 = t_45[t_43];
frame.set("slug", t_46);
frame.set("loop.index", t_43 + 1);
frame.set("loop.index0", t_43);
frame.set("loop.revindex", t_44 - t_43);
frame.set("loop.revindex0", t_44 - t_43 - 1);
frame.set("loop.first", t_43 === 0);
frame.set("loop.last", t_43 === t_44 - 1);
frame.set("loop.length", t_44);
var t_47;
t_47 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_46);
frame.set("navItem", t_47, true);
if(frame.topLevel) {
context.setVariable("navItem", t_47);
}
if(frame.topLevel) {
context.addExport("navItem", t_47);
}
var t_48;
t_48 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug");
frame.set("itemSlug", t_48, true);
if(frame.topLevel) {
context.setVariable("itemSlug", t_48);
}
if(frame.topLevel) {
context.addExport("itemSlug", t_48);
}
t_42 += "<p class=\"c-off-navigation-accordion__p\">\n            <a class=\"c-off-navigation-accordion__a\" data-qa-navitem=\"\" href=\"";
t_42 += runtime.suppressValue((lineno = 139, colno = 90, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "itemSlug")])), env.opts.autoescape);
t_42 += "\">";
t_42 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_42 += "</a>\n        </p>";
;
}
}
frame = frame.pop();
;
frame = frame.pop();
return new runtime.SafeString(t_42);
});
context.addExport("buildOffscreenNav");
context.setVariable("buildOffscreenNav", macro_t_41);
var macro_t_49 = runtime.makeMacro(
["categorySlug", "core"], 
[], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
var t_50 = "";if(runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)) {
var t_51;
t_51 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)),"parentSlug");
frame.set("currentNavigationItemParentSlug", t_51, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParentSlug", t_51);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParentSlug", t_51);
}
var t_52;
t_52 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentSlug"));
frame.set("currentNavigationItemParentObject", t_52, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParentObject", t_52);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParentObject", t_52);
}
if(runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentObject")) {
t_50 += "<a href=\"";
t_50 += runtime.suppressValue((lineno = 160, colno = 29, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentSlug")])), env.opts.autoescape);
t_50 += "\" class=\"js-category-navigation__a c-filter-navigation__a--parent-category\">";
t_50 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentObject")),"displayName"), env.opts.autoescape);
t_50 += "</a>";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_50);
});
context.addExport("getParent");
context.setVariable("getParent", macro_t_49);
var macro_t_53 = runtime.makeMacro(
["categorySlug", "core"], 
["class"], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_54 = "";var t_55;
t_55 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug);
frame.set("currentNavigationItem", t_55, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItem", t_55);
}
if(frame.topLevel) {
context.addExport("currentNavigationItem", t_55);
}
var t_56;
t_56 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"type");
frame.set("currentCategoryPageType", t_56, true);
if(frame.topLevel) {
context.setVariable("currentCategoryPageType", t_56);
}
if(frame.topLevel) {
context.addExport("currentCategoryPageType", t_56);
}
var t_57;
t_57 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"parentSlug"));
frame.set("currentNavigationItemParent", t_57, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParent", t_57);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParent", t_57);
}
if(runtime.contextOrFrameLookup(context, frame, "currentCategoryPageType") != "Gateway" && runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs")) > 0) {
t_54 += runtime.suppressValue((lineno = 184, colno = 30, runtime.callWrap(macro_t_31, "loopThroughChildSlugs", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
else {
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_54);
});
context.addExport("getSiblings");
context.setVariable("getSiblings", macro_t_53);
var macro_t_58 = runtime.makeMacro(
["categorySlug", "core"], 
[], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
var t_59 = "";t_59 += "\n    ";
t_59 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)),"displayName"), env.opts.autoescape);
t_59 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_59);
});
context.addExport("getCurrentCategory");
context.setVariable("getCurrentCategory", macro_t_58);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/alternate-category-facet-macro.j2"] , dependencies)